import { Editor, useMonaco, loader } from '@monaco-editor/react';
const baseUrl = new URL('.', import.meta.url).href;
const BasePath = baseUrl.split('/').slice(0, -1).join('/');
loader.config({
    paths: { vs: BasePath + '/monaco/min/vs' },
});
window.UXPMonaco = {
    Editor,
    useMonaco,
    loader,
};
